var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntertainment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "m23.837 6.404-2.93-2.336c-2.59-2.067-6.365-1.642-8.431.949-.104.13-.203.265-.296.404l-8.596 12.843c-1.536 2.295-.92 5.4 1.374 6.936.348.233.724.422 1.12.56l28.892 10.183c3.966 1.397 8.38.027 10.856-3.37l1.768-2.426c1.342-1.841.986-4.415-.807-5.822l0 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "25.937 6.489 38.455 6.497 38.464 20.414 25.946 20.406",
    transform: "rotate(-52 32.2 13.452)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "42.573 14.927 42.576 18.406 30.058 18.398 30.056 14.919",
    opacity: 0.303,
    transform: "rotate(-52 36.316 16.662)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "37.887 17.908 45.654 17.913 45.657 22.797 37.89 22.792",
    transform: "rotate(-52 41.772 20.353)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "46.65 19.949 46.652 22.391 38.886 22.386 38.719 19.987",
    opacity: 0.301,
    transform: "rotate(-52 42.686 21.17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.2f5ddcaefa643bba8590ccb5ef1f6ff8.svg";
export { ForwardRef as ReactComponent };